import React, { useEffect, useState } from 'react';
import './leftTime.css';
import { Row, Col } from 'react-bootstrap';

const RefreshTimeLeft = (data) => {
  const { props } = data;
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const dateExpirationToken = props.expiration;
    const limitExpirationToken = (props.expirationSecondsToken / 60);

    const calculateTimeLeft = () => {
      const now = new Date();
      const expiration = new Date(dateExpirationToken);
      const diff = expiration - now;
    
      if (diff <= 0) return {};
    
      const totalSeconds = Math.floor(diff / 1000);
      const totalMinutes = Math.floor(totalSeconds / 60);
      const totalHours = Math.floor(totalMinutes / 60);
      const totalDays = Math.floor(totalHours / 24);
      if (diff < 60 * 1000) {
        return {
          minutes: totalMinutes,
          seconds: totalSeconds % 60,
          label: 'minutes',
        };
      } else if (diff < 60 * 60 * 1000) {
        return {
          minutes: totalMinutes,
          seconds: totalSeconds % 60,
          label: 'minutes',
        };
      } else if (diff < 24 * 60 * 60 * 1000) {
        return {
          hours: totalHours,
          minutes: totalMinutes % 60,
          seconds: totalSeconds % 60,
          label: 'hours',
        };
      } else {
        return {
          days: totalDays,
          hours: totalHours % 24,
          minutes: totalMinutes % 60,
          label: 'days',
        };
      }
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  });

  const setTimer = (timeLeft) => {
    let times = {
      primaryTime: '00',
      secondaryTime: '00',
    };
    switch (timeLeft.label) {
      case 'hours':
        times = {
          primaryTime: zeroOnLeft(timeLeft.hours),
          primaryLabel: 'hrs',
          secondaryTime: zeroOnLeft(timeLeft.minutes),
          secondaryLabel: 'min',
        };
        break;
      case 'minutes':
        times = {
          primaryTime: zeroOnLeft(timeLeft.minutes),
          primaryLabel: 'min',
          secondaryTime: zeroOnLeft(timeLeft.seconds),
          secondaryLabel: 'seg',
        };
        break;
      case 'days': 
        times = {
          primaryTime: zeroOnLeft(timeLeft.days),
          primaryLabel: 'días',
          secondaryTime: zeroOnLeft(timeLeft.hours),
          secondaryLabel: 'hrs',
        };
        break;
    }
    return times;
  };

  const getTimer = setTimer(timeLeft);

  return (
    <div className={'time-left-box'}>
      <Row>
        <Col xs={12}>
          <p className={'time-left-text'}>Tiempo restante</p>
            <div>
              <div className={'time-section'}>
                <span className={'minutes'}>{getTimer.primaryTime}</span>
                <span className={'separator'}>:</span>
                <span className={'seconds'}>{getTimer.secondaryTime}</span>
              </div>
              <div className={'time-group'}>
                <span className={'label'}>{getTimer.primaryLabel}</span>
                <span className={'label'}></span>
                <span className={'label'}>{getTimer.secondaryLabel}</span>
              </div>
            </div>
        </Col>
      </Row>
    </div>
  );
};

const zeroOnLeft = (number) => {
  return number.toString().padStart(2, '0');
};

export default RefreshTimeLeft;